export default __webpack_public_path__ + "static/friend_04-eed1c8695324bde5b7140aa3edb803ff.png";